import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShiftEntity } from '../../domain/entities/ShiftEntity'
import moment from 'moment'
export class ShiftModel extends ShiftEntity {
  regionId?: number
  regionName?: string
  constructor(dataDto: ShiftModel) {
    super()
    mapEntityProperties<ShiftEntity>(this, dataDto, {
      map: {
        duration: new Date(moment(dataDto.duration, 'HH:mm:00').format('')),
        region: {
          id: dataDto.regionId,
          name: dataDto.regionName
        }
      }
    })
  }
}
